import { restApiRequest, restApiRequestPost, getErrorMessage } from './ajax'
import * as types from '../mutation-types'

const creativeSetting = {
  namespaced: true,
  state: {
    creativeSettingList: {}
  },
  getters: {
    creativeSettingList: state => state.creativeSettingList
  },
  mutations: {
    [types.RECEIVE_CREATIVE_SETTING](state, creativeSettingList) {
      state.creativeSettingList = creativeSettingList
    }
  },
  actions: {
    /**
     * クリエイティブ設定確認用の一覧を取得する
     * @param {*} params
     */
    getCreativeSettingList: function({ commit }, params) {
      return new Promise((resolve, reject) => {
        const baseURL = process.env.BaseURL
        const agencyId = params.agencyId
        const advertiserId = params.advertiserId
        const campaignIds = params.campaignIds
        restApiRequestPost(
          baseURL,
          `/api/campaign/landing/creative-list/${params.privateCode}/${agencyId}/${advertiserId}/${campaignIds}`,
          params.jwtToken,
          params
        )
          .then(result => {
            if (result.status === 200) {
              let res = parse(result)
              commit(types.RECEIVE_CREATIVE_SETTING, res.creativeSettingList)
              resolve(res)
            } else {
              reject(new Error('Irregular Error.'))
            }
          })
          .catch(err => {
            if (!err) {
              resolve(undefined)
            } else if (!err.response) {
              reject(new ReferenceError('commons.restapi.system.error'))
              return
            } else if (err.response.data.errorCode === 'permission.expiration.error') {
              reject(new Error(getErrorMessage(err.response.data.errorCode)))
              return
            }
            reject(new ReferenceError(getErrorMessage(err.response.data.errorCode)))
          })
      })
    },
    getFilterList: function({ commit }, params) {
      return new Promise((resolve, reject) => {
        const baseURL = process.env.BaseURL
        const agencyId = params.agencyId
        const advertiserId = params.advertiserId

        restApiRequest(baseURL, `/api/campaign/landing/filter/${params.privateCode}/${agencyId}/${advertiserId}`, params.jwtToken, params)
          .then(result => {
            if (result.status === 200) {
              resolve(parse(result))
            } else {
              reject(new Error('Irregular Error.'))
            }
          })
          .catch(err => {
            if (!err) {
              resolve(undefined)
              return
            } else if (!err.response) {
              reject(new ReferenceError('commons.restapi.system.error'))
              return
            } else if (err.response.data.errorCode === 'permission.expiration.error') {
              reject(new Error(getErrorMessage(err.response.data.errorCode)))
              return
            }
            reject(new ReferenceError(getErrorMessage(err.response.data.errorCode)))
          })
      })
    },
    reset: function({ commit }) {
      commit(types.RECEIVE_CREATIVE_SETTING, undefined)
    }
  }
}
function parse(response) {
  return response.data
}
export default creativeSetting
